import { ReactComponent as NewInterviewLogo } from "../../assets/icons/NewInterviewLogo.svg";
import { ReactComponent as AddStudentLogo } from "../../assets/icons/AddStudentLogo.svg";
import { ReactComponent as UploadQuestionLogo } from "../../assets/icons/UploadQuestionLogo.svg";
import { useDispatch } from "react-redux";
import { setOpenModal } from "../../store/interviewConfigReducer";
import { setCreateStudentModal } from "../../store/studentManagementReducer";
import { toggleModalOpen, resetScheduleForm, clearEditingSchedule } from "../../store/schedulingReducer";
import { SIDE_BAR_ITEMS } from "../features/common/Constants";
import ActionButton from "../features/common/ActionButton";
import "./Style.css";

const LeftSideComponent = ({ setActivePage }) => {
  const dispatch = useDispatch();

  const handleMixMatchClick = () => {
    if (setActivePage) {
      setActivePage(SIDE_BAR_ITEMS.INTERVIEW_CONFIG);
    }
    dispatch(setOpenModal(true));
  };

  const handleAddStudentClick = () => {
    if (setActivePage) {
      setActivePage(SIDE_BAR_ITEMS.STUDENT_MANAGEMENT);
    }
    dispatch(setCreateStudentModal(true));
  };

  const handleScheduleInterviewClick = () => {
    if (setActivePage) {
      setActivePage(SIDE_BAR_ITEMS.SCHEDULING);
    }
    dispatch(clearEditingSchedule());
    dispatch(resetScheduleForm());
    dispatch(toggleModalOpen(true));
  };

  return (
    <div className="dashboard-quick-actions-container">
      <h3 className="dashboard-quick-actions-title">
        Quick Actions
      </h3>
      <div className="dashboard-quick-actions-list">
        <ActionButton
          Icon={NewInterviewLogo}
          label="Mix & Match Interview"
          bgColor="bg-yellow-600"
          hoverColor="bg-yellow-800"
          onClick={handleMixMatchClick}
        />
        <ActionButton
          Icon={AddStudentLogo}
          label="Add Student"
          bgColor="bg-blue-600"
          hoverColor="bg-blue-700"
          onClick={handleAddStudentClick}
        />
        <ActionButton
          Icon={UploadQuestionLogo}
          label="Schedule Interview"
          bgColor="bg-green-600"
          hoverColor="bg-green-700"
          onClick={handleScheduleInterviewClick}
        />
      </div>
    </div>
  );
};

export default LeftSideComponent;
